import { NotificationConfiguration } from '../notification.templates';

export const PUBLISH_MEETING_MINUTES_TEMPLATE: NotificationConfiguration = {
  inapp: `<b>{triggeredByName}</b> published meeting minutes.`,

  email: {
    ctaKey: 'go_to_meeting',
  },
};
